import { Directive, ElementRef } from '@angular/core';

@Directive({
  selector: 'textarea[autoResize]'
})

export class AutoResizeDirective {
  constructor(private el: ElementRef<HTMLTextAreaElement>) {}

  ngAfterViewInit(): void {
    requestAnimationFrame(() => this.resize());
  }

  private resize(): void {
    const textarea = this.el.nativeElement;
    textarea.style.height = 'auto';
    textarea.style.height = textarea.scrollHeight + 'px';
  }
}
